import { Device_MANUFACTURE_Detail_Interface } from './Device_MANUFACTURE_Detail_Interface'

export interface Device_MANUFACTURE_Interface {
  id:number,
  device_id:number,
  mANUFACTURE:String,
  mODEL:String,
  username:String,
  persianDate:String,
  del:boolean,
  detail:Array<Device_MANUFACTURE_Detail_Interface>
}

export function Empty_Device_MANUFACTURE_Interface(){
  return{
    id:0,
    device_id:0,
    mANUFACTURE:'',
    mODEL:'',
    username:'',
    persianDate:'',
    del:false,
    detail:[]
  }
}
